import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import coreService from "@/utils/axios/core-service";
import { API_ENDPOINTS, RESPONSE_STATUSES } from "@/constants/api-endpoints";
import { MARKET_PLACES } from "@/constants/app";

// 🚀 Fetch all eBay discount setting data
export const fetchEbayDiscountSettingData = createAsyncThunk(
  "discountSettings/fetchAll",
  async (
    {
      page = 0,
      size = 100,
      marketplace = MARKET_PLACES.EBAY,
      body = [
        {
          fieldName: "marketPlace",
          fieldValue: marketplace,
          searchOperator: "LIKE",
        },
      ],
    } = {},
    thunkAPI,
  ) => {
    try {
      const response = await coreService.post(
        `${API_ENDPOINTS.ADMIN.SETTINGS.EBAY.DISCOUNT_SETTINGS.GET_ALL}?page=${page}&size=${size}&sort=id,asc`,
        body,
      );

      if (response.data?.status == RESPONSE_STATUSES.SUCCESS) {
        return response.data?.data?.content || [];
      }

      return thunkAPI.rejectWithValue("Unexpected response from server");
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.message || "API error");
    }
  },
);
export const createOrUpdateDiscountSettings = createAsyncThunk(
  "discountSettings/cerateOrUpdateDiscountSettings",
  async ({ marketplace, payload, page, size, t }, thunkAPI) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await coreService.post(
          API_ENDPOINTS.ADMIN.SETTINGS.EBAY.DISCOUNT_SETTINGS.CREATE,
          payload,
        );

        if (response.data.status == RESPONSE_STATUSES.CREATED) {
          // 🔥 Refetch after success
          thunkAPI.dispatch(
            fetchEbayDiscountSettingData({ marketplace, page, size }),
          );

          resolve(t("discountSettingsUpdateSuccesfully"));
        } else {
          reject(t("failedToUpdateDiscountSettings"));
        }
      } catch (err) {
        reject(err?.message);
      }
    });
  },
);
// ⭐ Slice
const discountSettingSlice = createSlice({
  name: "discountSetting",
  initialState: {
    discountSettingData: [],
    discountSettingLoading: false,
    discountSettingError: null,
    submitLoading: false,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchEbayDiscountSettingData.pending, (state) => {
        state.discountSettingLoading = true;
        state.discountSettingError = null;
      })
      .addCase(fetchEbayDiscountSettingData.fulfilled, (state, action) => {
        state.discountSettingLoading = false;
        state.discountSettingData = action.payload;
      })
      .addCase(fetchEbayDiscountSettingData.rejected, (state, action) => {
        state.discountSettingLoading = false;
        state.discountSettingError = action.payload;
        state.discountSettingData = [];
      })
      // SUBMIT
      .addCase(createOrUpdateDiscountSettings.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(createOrUpdateDiscountSettings.fulfilled, (state) => {
        state.submitLoading = false;
      })
      .addCase(createOrUpdateDiscountSettings.rejected, (state) => {
        state.submitLoading = false;
      });
  },
});

export default discountSettingSlice.reducer;
